import LS from '../../common/cache'

const state = {
  phone: ''
}

const mutations = {
  updatePhone (state, data) {
    state.phone = data
  },
  getMyCarInfoFromLS (state) { // localStorage:get
    let phone = LS.getLocalStorageData('phone') || ''
    if (phone !== '') state.phone = phone
  },
  setMyCarInfoToLS (state) { // localStorage:set
    LS.setLocalStorageData('phone', state.phone)
  }
}

const actions = {
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/veri.js